import React from 'react'
import { Link } from "gatsby"
import Formthema from '../assets/Logo12.png'

const Form = () => {
    return (
        <div className='w-full max-w-sm pt-5'>
            <img className='w-auto animation-ronsof-one' src={Formthema} alt='Formthema' />
            <form className='color-al-4  shadow-md rounded px-8 pt-6 pb-8 mb-4' method="post" action="https://formspree.io/mpzyynro">
                <label className='block text-gray-700 text-sm font-bold mb-2'>
                    Name Completo
                    <input className='animation-ronsof-one shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline' type="text" name="name" id="name" />
                </label>
                <label className='block text-gray-700 text-sm font-bold mb-2'>
                    E-mail
                    <input className='animation-ronsof-one shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline' type="email" name="_replyto" id="email" />
                </label>
                <label className='block text-gray-700 text-sm font-bold mb-2'>
                    Telefone
                    <input className='animation-ronsof-one shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline' type="number" name="Telefone" id="number" />
                </label>
                <label className='block text-gray-700 text-sm font-bold mb-2'>
                    Assunto
                    <input className='animation-ronsof-one shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline' type="text" name="subject" id="subject" />
                </label>
                <label className='block text-gray-700 text-sm font-bold mb-2'>
                    Mensagem
                    <textarea className='animation-ronsof-one shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline' name="message" id="message" rows="5" />
                </label>
        
                <button className='
                btn-ronsof-one-green-sb shadow-lg my-1' type="submit">Enviar</button>
                <input className='btn-ronsof-one-white shadow-lg ml-2 lg:ml-5 my-1' type="reset" value="Cancelar" />
                
            </form>
        </div>
    )
}
export default Form

